import { ModalCustom } from "components/ModalCustom";
import { PrimaryButton } from "components/Button/style";
import { IconeContainer, InfoContainer, TextContainer } from "./style";
import { FaExclamation } from "react-icons/fa";

interface Props {
  show: boolean;
  handleClose: () => void;
  onConfirmar: () => void;
}

export function ModalConfirmarBloqueio({ show, handleClose, onConfirmar }: Props) {
  return (
    <ModalCustom show={show} handleClose={handleClose} title="Bloquear veículo" centered>
      <InfoContainer>
        <IconeContainer>
          <FaExclamation />
        </IconeContainer>
        <TextContainer>Deseja bloquear o veículo?</TextContainer>
      </InfoContainer>
      <div className="d-flex justify-content-between gap-4 mt-4">
        <PrimaryButton style={{ width: "14rem" }} outline variante="primary" onClick={handleClose}>
          Cancelar
        </PrimaryButton>
        <PrimaryButton style={{ width: "14rem" }} onClick={onConfirmar}>
          Confirmar
        </PrimaryButton>
      </div>
    </ModalCustom>
  );
}
